<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="sub-grupo-produto vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t('sub-grupos-produto') }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            isVenda ? $t('vendas') : $t('promotor')
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            isVenda ? $t('produto') : $t('cadastros')
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t('sub-grupos-produto')
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !subgrupoIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: isVenda
                                            ? 'ven-produto-sub-grupo-new'
                                            : 'new-subgrupo',
                                    })
                                "
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-two-quarters">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                                tooltipLabel="msg-campo-busca-subgrupo-de-produto"
                            />
                        </div>

                        <!-- GRUPOS -->
                        <div class="situacao-select column is-one-quarter">
                            <vss-select
                                ref="grupoSelect"
                                :options="grupos"
                                v-model="grupo"
                                class="no-clear"
                                title="grupo"
                                :height="40"
                                @input="carregarDados('')"
                            />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{
                                    $t('sem-resultados')
                                }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="sub-grupo-produto-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="allsgps"
                            :mobile-cards="false"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.delete && !subgrupoIntegracao"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        @click="confirmaAtivacaoDesativacao(props.row)"
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        position="is-left"
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>
                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: isVenda
                                                ? 'ven-produto-sub-grupo-edit'
                                                : 'edit-subgrupo',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'grupoproduto'">
                                    <pre>{{ props.row[f.key] }}</pre>
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t('ativo') }}</b-tag
                                    >
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t('inativo') }}</b-tag
                                    >
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import SubGrupoProdutoService from '@/services/SubGrupoProdutoService';
import GrupoProdutoService from '@/services/GrupoProdutoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            [
                'ven-produto-sub-grupo-new',
                'ven-produto-sub-grupo-edit',
                'new-subgrupo',
                'edit-subgrupo',
            ].includes(to.name)
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            subgrupoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('SUBGRUPOPRODUTO'),
            allsgps: [],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: new SubGrupoProdutoService(this.$http, this.$router),
            serviceGrupo: new GrupoProdutoService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: '10%', sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                {
                    key: 'grupoproduto',
                    width: 300,
                    sortable: true,
                    sortFn: null,
                },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            sort: {
                order: 'desc',
                column: 'DESCRICAO',
            },
            isLoading: false,
            isEmpty: false,
            queryFilter: '',
            changeThis: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            // @84563 - Criação da variável para verificar a origem da rota;
            // Esta variável é utilizada sempre que for necessário verificar se a origem é vendas ou promotor
            isVenda: 'vendas' === this.$route.meta.contexto ? true : false,
            // @84563 - Criação de variáveis para listagem de empresas
            grupos: [],
            grupo: { id: 0, label: this.$t('todos').toUpperCase() },
            empresas: [],
        };
    },
    created() {
        if (
            [
                'ven-produto-sub-grupo-new',
                'ven-produto-sub-grupo-edit',
                'new-subgrupo',
                'edit-subgrupo',
            ].includes(this.$route.name)
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.permissao = this.isVenda
            ? this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-subgrupo')
            : this.hasPermissionAccess('promotor', 'cadastros', 'subgrupos');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'sub-grupos-produto' },
            });
        } else {
            this.loadEmpresasId();
            this.loadComboGrupo('');
        }
    },
    methods: {
        // @84563 - Carregar combo grupos associados as empresas que o usuário tem vínculo
        loadComboGrupo(search) {
            let empresas = '0, ';
            for (let e of this.empresas) {
                empresas += `${e.id}, `;
            }
            empresas = empresas.slice(0, -2);
            this.serviceGrupo
                .findAllComboWithEmpresa(empresas, search)
                .then((body) => {
                    this.grupos = [];
                    if (search === '') {
                        let grupo = {
                            id: 0,
                            label: this.$t('todos').toUpperCase(),
                        };
                        this.grupos.push(grupo);
                    }
                    body.content.map((r) => {
                        let grupo = {
                            id: r.idgrupoproduto,
                            label: r.descricao,
                        };
                        this.grupos.push(grupo);
                    });
                    this.grupos.sort();
                    this.grupo = this.grupos[0];
                }, 350)
                .finally((_) => {
                    this.carregarDados();
                });
        },
        // @84563 - Carregar empresas que o usuário tem vínculo
        loadEmpresasId() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            }
        },
        sortTable(field, order) {
            this.sort.column = field == 'codigo' ? 'idsubgrupoprodutoerp' : field;
            this.sort.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSituacaoChanged(situacao) {
            this.situacao = situacao;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            let grupo = this.grupo.id;
            this.service
                .findAll(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.sort,
                    grupo,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allsgps = value;
                    this.isEmpty = this.allsgps.length <= 0;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let sgplist = [];
            if (body.content) {
                sgplist = body.content.map((sgp) => {
                    return {
                        id: sgp.idsubgrupoproduto,
                        codigo: sgp.idsubgrupoprodutoerp,
                        descricao: sgp.descricao,
                        excluir: 'excluir-sub-grupo-produto',
                        situacao: sgp.situacao,
                        grupoproduto: sgp.grupoproduto.descricao,
                    };
                });
            }
            return sgplist;
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        confirmaAtivacaoDesativacao(item) {
            this.changeThis = item;
            this.$root.confirm({
                message:
                    item.situacao == 1
                        ? this.$t('msg-confirmacao-desativacao-subgrupoproduto-n', { n: item.descricao })
                        : this.$t('msg-confirmacao-reativacao-n', { n: item.descricao }),
                onConfirm: this.changeSituacao,
                onCancel: (_) => {
                    this.changeThis = null;
                },
            });
        },
        updateSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        changeSituacao() {
            let item = {
                idsubgrupoproduto: this.changeThis.id,
                situacao: this.changeThis.situacao,
            };
            this.isLoading = true;
            this.service
                .changeSituacao(item)
                .then((_) => {
                    if (item.situacao == 1) {
                        this.$root.showMessage(
                            'success',
                            'msg-sucesso-ao-desativar-subgrupoproduto'
                        );
                    } else {
                        this.$root.showMessage(
                            'success',
                            'msg-sucesso-ao-reativar-subgrupoproduto'
                        );
                    }
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error('Erro ao alterar situacao do subgrupo.', e);
                    if (item.situacao == 1) {
                        this.$root.showMessage('error', 'msg-erro-ao-desativar-subgrupoproduto');
                    } else {
                        this.$root.showMessage('error', 'msg-erro-ao-reativar-subgrupoproduto');
                    }
                    this.isLoading = false;
                })
                .finally((_) => {
                    this.changeThis = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    min-height: calc(100% - 50px);

    .page {
        position: relative;
        padding-left: 0;
        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
    }
    .sub-grupo-produto .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .sub-grupo-produto .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
